import './home.scss'
import React, { useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import SearchView from './searchView'
import DetailView from './detailView'
import logo_small from '../../images/logo_small.png'

const Home = () => {
  const goToHome = () => (window.location.href = '/home')
  const [view, setView] = useState('home')
  const [searchedAccountEmails, setSearchedAccountEmails] = useState([])
  const [searchedAccountID, setSearchedAccountID] = useState('')
  const [searchedAccountStatus, setsearchedAccountStatus] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const history = useHistory()

  return (
    <>

      <img
        src={logo_small}
        alt="CSIO logo"
        width="104px"
        height="26px"
        onClick={goToHome}
        className="csio-logo"
      />
      {view == 'home' ? (
        <>
          <SearchView
            setSearchedAccountID={setSearchedAccountID}
            showSuccessModal={showSuccessModal}
            setShowSuccessModal={setShowSuccessModal}
            setSearchedAccountEmails={setSearchedAccountEmails}
            setsearchedAccountStatus={setsearchedAccountStatus}
            setView={setView}
            history={history}
          />
        </>
      ) : (
        <>
          <DetailView
            history={history}
            searchedAccountID={searchedAccountID}
            searchedAccountEmails={searchedAccountEmails}
            searchedAccountStatus={searchedAccountStatus}
            setView={setView}
            setSearchedAccountEmails={setSearchedAccountEmails}
          />
        </>
      )}
    </>
  )
}

export default Home
